import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/Hero';
import Services from '../../components/Services';
import CaseStudies from '../../components/CaseStudies';
import PricingPackages from '../../components/PricingPackages';
import FAQ from '../../components/FAQ';
import Blog from '../../components/Blog';
import Contact from '../../components/Contact';

const HomePage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.scrollTo) {
            const id = location.state.scrollTo;
            // Delay to ensure components mounted
            setTimeout(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 50);
        }
    }, [location.state]);

    return (
        <main>
            <Hero />
            <Services />
            <CaseStudies />
            <PricingPackages />
            <FAQ />
            <Blog />
            <Contact />
        </main>
    );
};

export default HomePage;
